import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Components - imported
import { Avatar, Button } from '@material-ui/core';

// Icons
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const ChooseSport = ({
    slideform1, 
    setSlideForm1,
    slideform2, 
    setSlideForm2,
    sportType,
    setSportType, 
    onChange,
    user,
    is_create_page
}) => {

    // Toggle the value of slideform1 to go back to the previous form step
    const goBack = (e) => {
        setSlideForm1(!slideform1);
    }

    // Toggle the slideform1 state variable (go to next page in slide form)
    const todo = (e) => {
        setSlideForm2(!slideform2);
    }

    return (
        <div className="form-transition-element">

            {/* Back Button */}
            {!is_create_page && (
                <div onClick={goBack} className="form__backBtn">
                    <ArrowBackIcon />
                </div>
            )}

            {/* Display the heading */}
            <div>
                <h2>Choose Sport</h2>
            </div>

            <div className="modal__inputs" style={{flex:1, paddingLeft:'5px'}}>
                <div style={{ padding:'0 10px', display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
                    
                    {/* Football */}
                    <div onClick={() => setSportType('football')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                        {sportType === 'football' ? (
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                            </div>
                        ) : (
                            <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                        )}
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                            <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Football</p>
                        </div>
                    </div>

                    {/* Soccer */}
                    <div onClick={() => setSportType('soccer')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                        {sportType === 'soccer' ? (
                            <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                            </div>
                        ) : (
                            <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                        )}
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                            <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Soccer</p>
                        </div>
                    </div>
                </div>
            </div>

            <Button 
                disabled={!sportType?.length > 0}
                onClick={todo}
                variant="outlined" 
                className={`sidebar__tweet ${sportType?.length > 0 ? 'black' : 'ghost'}`}
                fullWidth
            >
                Next
            </Button>

            <Button 
                onClick={goBack}
                variant="outlined" 
                className="sidebar__tweet heart"
                fullWidth
            >
                Go Back
            </Button>

        </div>
    )
}

ChooseSport.propTypes = {

}

export default ChooseSport
